import type { DrawingAccessRole } from "@excalidraw-ms/shared";

export function shouldAutoJoinFileCollaboration(
  activeCollaborators: number,
  role: "owner" | DrawingAccessRole,
  isShared: boolean,
): boolean {
  return isShared || role !== "owner" || activeCollaborators > 0;
}
